import { render, staticRenderFns } from "./purstatbuyer.vue?vue&type=template&id=0dcfc4a3&scoped=true&"
import script from "./purstatbuyer.vue?vue&type=script&lang=js&"
export * from "./purstatbuyer.vue?vue&type=script&lang=js&"
import style0 from "./purstatbuyer.vue?vue&type=style&index=0&id=0dcfc4a3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcfc4a3",
  null
  
)

export default component.exports